import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { PlainModal } from '@client/new/components/Modal/Modal';
import { colors } from '@client/new/components/colors';
import livestreamingImage from '/static/images/livestreaming.png';

type LivestreamingModalProps = {
  open: boolean;
  toggle: () => void;
  onSubmit: () => Promise<void>;
  isEnabled: boolean;
  isSubmitting: boolean;
};

const getModalConfig = (isEnabled: boolean) => {
  if (isEnabled) {
    return {
      title: 'Are you sure?',
      description:
        'You won’t be able to stream your content directly to your audience',
      submitLabel: 'Disable Live Streaming',
      actionButtonSx: { backgroundColor: colors.error100 },
    };
  }
  return {
    title: 'Ready for Live Streaming?',
    description:
      'Start streaming content live to your audience and share your motivation!',
    submitLabel: 'Enable Live Streaming',
  };
};

export const LivestreamingModal = ({
  isEnabled,
  open,
  toggle,
  onSubmit,
  isSubmitting,
}: LivestreamingModalProps) => {
  const { title, description, submitLabel, actionButtonSx } =
    getModalConfig(isEnabled);

  return (
    <PlainModal
      isOpen={open}
      onClose={toggle}
      height={'auto'}
      sx={{
        padding: '32px',
        maxWidth: '415px',
        maxHeight: 'fit-content',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: 16,
        }}
        className="flex flex-col gap-6 justify-center items-center"
      >
        <img src={livestreamingImage} className="max-w-[265px]" />
        <div className="flex flex-col justify-center items-center gap-4">
          <Typography sx={{ fontSize: 24, fontWeight: 700 }}>
            {title}
          </Typography>
          <Typography
            sx={{ fontSize: 14, fontWeight: 500, textAlign: 'center' }}
          >
            {description}
          </Typography>
        </div>
        <div className="w-full flex flex-col justify-center gap-2">
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{
              width: '100%',
              ...(actionButtonSx || {}),
            }}
          >
            {isSubmitting ? (
              <CircularProgress className="h-[20px] w-[20px]" />
            ) : (
              submitLabel
            )}
          </Button>
          <Button variant="text" onClick={toggle}>
            Cancel
          </Button>
        </div>
      </Box>
    </PlainModal>
  );
};
